export default {
  props: {
    // 控制弹框的样式
    boxStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    // 控制弹框内头部样式
    topStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    // 控制弹框内容的样式
    contentStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    // 控制弹框内底部的样式
    footerStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    // 弹框头部图片
    bdImg: {
      type: String,
      default: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/logo%402x%402x.png'
    },
    // 弹框内容的subTitle
    subTitle: {
      type: String,
      default: '新手导航、定制足迹，免费安装'
    },
    // 弹框内容的title
    title: {
      type: String,
      default: '百度地图全新升级'
    },
    // 弹框底部的按钮
    btnArr: {
      type: Array,
      default() {
        return [{
          text: '取消',
          type: 'outline',
          method: 'close'
        }, {
          text: '去体验',
          type: 'primary',
          method: 'jump'
        }];
      }
    },
    // 弹框蒙层显隐标志
    downloadFlag: {
      type: Boolean,
      default: true
    },
    // 控制高度
    containerStyle: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleClick(data = {}) {
      this.$emit('handleClick', data);
    }
  }
};